<template>
	<div class="test_complete">
		<div>
			<div class="test_complete_title">
				Felicitaciones
			</div>
			<div class="test_complete_description">
				¡Felicitaciones por culminar exitosamente el proceso de diagnóstico! Nos
				complace informarte que has sido clasificado al 
				<b>"{{ this.recognition.name_course_to_study }}"</b> del nivel <b>{{ this.recognition.level }}</b> en nuestro programa
				<b>{{ this.programNameFinal }}</b
				>.
			</div>
			<div class="test_complete_image">
				<img src="@/assets/images/evaluation/complete.svg" />
			</div>
			<div class="test_complete_footer">
				<v-btn color="primary" class="uppercase" @click="goToMain">
					Continuar
				</v-btn>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
	methods: {
		goToMain() {
			this.$router.push({ path: `/principal` });
		},
	},
	computed: {
		...mapGetters({
			program: "program",
			recognition: "recognition",
		}),
		programNameFinal() {
			// Solo si el nivel es exactamente Communication Level 1., mostramos el nombre forzado
			if (this.recognition.name_course_to_study === 'Communication Level 1.') {
				return 'Communication Level.';
			}
			// Si no, mostramos lo que siempre salía
			return this.program.name;
		}
	},
	mounted() {
		console.log("TestRecognition - program", this.program);
		console.log("TestRecognition - recognition", this.recognition);
	},
};
</script>
